import { TReduxActions } from '../../types/redux';
import { IEstimationState } from '../../types/redux/estimation';
import { EActionTypes } from '../../actions/estimation';

export const initialState: IEstimationState = {
  sale: {
    data: null,
    isError: undefined,
    isFetching: undefined,
    filtersHash: undefined,
  },
  rent: {
    data: null,
    isError: undefined,
    isFetching: undefined,
    filtersHash: undefined,
  },
};

export const estimationReducer = (state = initialState, action: TReduxActions): IEstimationState => {
  switch (action.type) {
    case EActionTypes.Request:
      return {
        ...state,
        [action.payload.dealType]: {
          ...state[action.payload.dealType],
          isError: false,
          isFetching: true,
        },
      };

    case EActionTypes.Success:
      return {
        ...state,
        [action.payload.dealType]: {
          ...state[action.payload.dealType],
          isFetching: false,
          isError: false,
          data: action.payload.data,
          filtersHash: action.payload.filtersHash,
        },
      };

    case EActionTypes.Failure:
      return {
        ...state,
        [action.payload.dealType]: {
          ...state[action.payload.dealType],
          isFetching: false,
          isError: true,
        },
      };

    case EActionTypes.Reset:
      return {
        ...state,
        [action.payload.dealType]: {
          ...state[action.payload.dealType],
          isError: false,
        },
      };

    default:
      return state;
  }
};
